import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import { OnInit } from '@angular/core';
@Directive({
  selector: '[appClientsReport]'
})
export class ClientsReportDirective implements OnInit {
  @Input() itm: any;
  constructor(private el: ElementRef, private renderer: Renderer2) { }
  ngOnInit(): void {
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML',
      `<div class="list-card-body card-body mt-0 pt-0 mb-0 pb-0 mx-0">
              <div class="row my-0 py-0">
                <div class="col-2 col-xl-1">
                  <img
                    class="img-circle mx-auto mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                    [src]="${this.itm.customerPhotoUrl}"
                    (click)="openModal(template, ${this.itm.customerPhotoUrl})"
                  />
                </div>
                <div class="col-10 col-xl-11">
                  <div class="row">
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-6 d-flex justify-content-start">
                          <span class="">Client ID</span>
                        </div>
                        <div
                          class="col-6 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                            ${this.itm.customerId}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-6 d-flex justify-content-start">
                          <span class="">Client Name</span>
                        </div>
                        <div
                          class="col-6 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                            ${this.itm.customerName}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-6 d-flex justify-content-start">
                          <span class="">Phone No.</span>
                        </div>
                        <div
                          class="col-6 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                              ${this.itm.customerPhone1}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-6 d-flex justify-content-start">
                          <span class="">Date Of Birth</span>
                        </div>
                        <div
                          class="col-6 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.customerDateOfBirth}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Id Type</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.customerIdType}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Id Number</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.customerIdNumber}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Home Area Details</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.customerHomeAreaDetails}
                          </span>
                        </div>
                      </div>
                    </div>
                    </div>
                  <div class="row">
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Products</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          <ul>
                            <li *ngIf="${this.itm.productCodes.includes(200)}">
                              BODABODA LOAN PRODUCT
                            </li>
                            <li *ngIf="${this.itm.productCodes.includes(300)}">
                              TAXI LOAN PRODUCT
                            </li>
                            <li *ngIf="${this.itm.productCodes.includes(400)}">
                              MICROLOAN PRODUCT
                            </li>
                            <li *ngIf="${this.itm.productCodes.includes(100)}">
                              SAVINGS PRODUCT
                            </li>
                          </ul>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Status</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.customerStatus}
                          </span>
                        </div>
                      </div>
                    </div><div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Station Name</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.stationName}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                      <div class="row">
                        <div class="col-5 d-flex justify-content-start">
                          <span class="">Comment</span>
                        </div>
                        <div
                          class="col-7 d-flex justify-content-start font-weight-bold"
                        >
                          <span class="itemCreated">
                          ${this.itm.customerComment}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>`);
  }
}
